import {useContext} from "react";
import MainApplicationContext from "../context/MainApplicationContext";

export const useMainApplicationContext = () => useContext(MainApplicationContext)